export default "__VITE_ASSET__CLE8CRj3__"